import dayjs from "dayjs";
import { Overlay } from "ol";
import WebGLPointsLayer from "ol/layer/WebGLPoints";
import VectorSource from "ol/source/Vector";


let intervalId;

export const pointTimeMap = ({ map, featureCollection, activeLayers, setActiveLayers }) => {
    const minDateInput = document.getElementById("minDateInput");
    const maxDateInput = document.getElementById("maxDateInput");
    const currentDateInput = document.getElementById("currentDateInput");

    const intervalSwiper = document.getElementById('intervalSwiper');
    const intervalStartButton = document.getElementById("intervalStartButton");
    const intervalStopButton = document.getElementById("intervalStopButton");
    const intervalResetButton = document.getElementById("intervalResetButton");

    const currentDateValue = document.getElementById("currentDate");


    let overlay;
    let date;

    let layer;
    let source;

    let minDate;
    let maxDate;
    let interval;

    const styleVariables = {
        currentDate: dayjs("2000-01-01").unix()
    }

    const onChangeIntervalHandle = () => {
        interval = intervalSwiper.value;
    }

    const onChangeMinDateHandle = () => {
        const minDateValue = document.getElementById("minDate").innerText;
        minDate = dayjs(minDateValue);
        if(date < minDate) {
            date = minDate;
        }
    }

    const onChangeMaxDateHandle = () => {
        const maxDateValue = document.getElementById("maxDate").innerText;
        maxDate = dayjs(maxDateValue);
    }

    

    const updateDate = () => {
        if (date.isAfter(maxDate)) {
            clearInterval(intervalId);
        } else {
            overlay.getElement().textContent = date.format("YYYY-MM");
            currentDateInput.value = date.diff(minDate, 'month');
            currentDateValue.textContent = date.format("YYYY-MM");
            styleVariables.currentDate = date.unix();
            
            map.render();
            date = date.add(1, "M");
        }
    };

    const renderDate = () => {
        if(source.getFeatures().length > 0) {
            onChangeIntervalHandle();
            onChangeMinDateHandle();
            onChangeMaxDateHandle();
    
            if(!date) {
                date = minDate;
            }
    
            if(intervalId) {
                clearInterval(intervalId);
            }
    
            intervalId = setInterval(updateDate, interval);
        }
    }

    const stopInterval = () => {
        clearInterval(intervalId)
    }

    const resetDate = () => {
        onChangeMinDateHandle();
        date = minDate;
        updateDate();
        stopInterval();
    }

    const inputDate = () => {
        onChangeMinDateHandle();
        onChangeMaxDateHandle();
        stopInterval();
        date = dayjs(currentDateValue.innerText).set("date", 1);
        updateDate();
    }

    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }

        source = new VectorSource({});

        date = dayjs(currentDateValue.innerText).set("date", 1);
                
        featureCollection.forEach((data) => {
            data.featureArray.forEach((feature) => {
                const clonedFeature = feature.clone();

                const permitDate = dayjs(feature.get("permit_issue_date")).set('date', 1).unix();
                const terminationDate = feature.get("termination_date") ? dayjs(feature.get("termination_date")).set('date', 1).unix() : 3000000000;

                clonedFeature.set("permitDate", permitDate);
                clonedFeature.set("terminationDate", terminationDate);
                
                source.addFeature(clonedFeature);

            })
        })

        const style = {
            variables: styleVariables,
            'circle-radius': [
                'case',
                ['==', ['var', 'currentDate'], ['get', 'terminationDate']],
                3,
                0
            ],
            'circle-stroke-width': [
                'case',
                ['==', ['var', 'currentDate'], ['get', 'terminationDate']],
                1,
                0
            ],
            'circle-stroke-color': [
                'case',
                ['==', ['var', 'currentDate'], ['get', 'terminationDate']],
                "#fff",
                "transparent"
            ],
            'circle-opacity': [
                'case',
                ['==', ['var', 'currentDate'], ['get', 'terminationDate']],
                0.7,
                0
            ],
            'circle-fill-color': [
                'case',
                ['==', ['var', 'currentDate'], ['get', 'terminationDate']],
                "#ff0000",
                "transparent"
            ],
        };
    
        
        layer = new WebGLPointsLayer({
            source: source,
            zIndex: 20,
            style: style
        })

        setActiveLayers([layer]);

        overlay = new Overlay({
            element: document.createElement('div'),
        });

        overlay.set("title", "pointTime")

        const overlayParent = overlay.getElement().parentElement;
        overlayParent.style.display = 'flex';
        overlayParent.style.position = 'absolute';
        overlayParent.style.bottom = '30px';
        overlayParent.style.left = '30px';
        overlayParent.style.fontSize = '18px';
        overlayParent.style.fontWeight = 'bold';

        map.addOverlay(overlay);

        minDateInput.addEventListener('change', onChangeMinDateHandle);
        maxDateInput.addEventListener('change', onChangeMaxDateHandle);
        intervalSwiper.addEventListener('change', onChangeIntervalHandle);
        intervalStartButton.addEventListener('click', renderDate);
        intervalStopButton.addEventListener('click', stopInterval);
        intervalResetButton.addEventListener('click', resetDate);
        currentDateInput.addEventListener('change', inputDate);

        updateDate();
    };

    const dismount = () => {
        const overlays = map.getOverlays().getArray();
        const pointTimeOverlay = overlays.filter((overlay) => overlay.get("title") === "pointTime");

        if(minDateInput) {
            minDateInput.removeEventListener('change', onChangeMinDateHandle);
        }
        if(maxDateInput) {
            maxDateInput.removeEventListener('change', onChangeMaxDateHandle);
        }
        if(intervalSwiper) {
            intervalSwiper.removeEventListener('change', onChangeIntervalHandle);
        }
        if(intervalStartButton) {
            intervalStartButton.removeEventListener('click', renderDate);
        }
        if(intervalStopButton) {
            intervalStopButton.removeEventListener('click', stopInterval);
        }
        if(intervalResetButton) {
            intervalResetButton.removeEventListener('click', resetDate);
        }
        if(currentDateInput) {
            currentDateInput.removeEventListener('click', inputDate);
        }

        pointTimeOverlay.forEach((overlay) => {
            map.removeOverlay(overlay);
        })

        clearInterval(intervalId)
        setActiveLayers();
        map.render();
    };

    return { mount: mount, dismount: dismount };
}
